module.exports = __webpack_public_path__ + "img/cloud-moon-rain.54cb2931.svg";